import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "suuryou claimCont cwC_2" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "suuryou claimCont cwC_2" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "tanka claimCont cwC_3" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "kingaku claimCont cwC_4" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "syouhizei claimCont cwC_5 selectedClear selectBorderNone disableWhite" }
const _hoisted_11 = { class: "zeikomi claimCont cwC_6" }
const _hoisted_12 = { class: "keisan claimCont cwC_7 selectBorderNone disableWhite" }
const _hoisted_13 = { class: "zeikomi claimCont cwC_8" }
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", {
      class: _normalizeClass(["koumoku claimCont cwC_1", { overLengthFrame: _ctx.isOverLength() }])
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: _normalizeClass(["", { overLength: _ctx.isOverLength() }]),
        disabled: _ctx.btnDisable,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.c_claim_det_item) = $event))
      }, null, 10, _hoisted_1), [
        [_vModelText, _ctx.item.c_claim_det_item]
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["icon-stack icon-stack-lg", { overLengthIcon: _ctx.isOverLength() }]),
        style: {"display":"none","color":"red","font-size":"12px"}
      }, _cache[12] || (_cache[12] = [
        _createElementVNode("i", {
          class: "fal fa-info-circle",
          style: {"font-size":"16px","margin-right":"5px"}
        }, null, -1),
        _createTextVNode("全角23文字を超えた場合、文字数に応じて表示サイズが縮小されます。"),
        _createElementVNode("br", null, null, -1),
        _createTextVNode("       視認性が低下する可能性がありますので、ご注意ください。 ")
      ]), 2)
    ], 2),
    _createElementVNode("td", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        style: {"text-align":"right","background":"none"},
        class: "",
        disabled: _ctx.btnDisable,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.c_claim_det_quantity) = $event))
      }, null, 8, _hoisted_3), [
        [_vModelText, _ctx.item.c_claim_det_quantity]
      ])
    ]),
    _createElementVNode("td", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        style: {"text-align":"right"},
        class: "",
        disabled: _ctx.btnDisable,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.c_claim_unit_symbol) = $event))
      }, null, 8, _hoisted_5), [
        [_vModelText, _ctx.item.c_claim_unit_symbol]
      ])
    ]),
    _createElementVNode("td", _hoisted_6, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        style: {"text-align":"right"},
        class: "",
        disabled: _ctx.btnDisable,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.c_claim_det_unitprice) = $event))
      }, null, 8, _hoisted_7), [
        [_vModelText, _ctx.item.c_claim_det_unitprice]
      ])
    ]),
    _createElementVNode("td", _hoisted_8, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        style: {"text-align":"right"},
        maxlength: "50",
        class: "",
        disabled: _ctx.btnDisable,
        onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.kanmaDel($event))),
        onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.kanmaIns($event))),
        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.calcTax())),
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.item.c_claim_det_price) = $event))
      }, null, 40, _hoisted_9), [
        [_vModelText, _ctx.item.c_claim_det_price]
      ])
    ]),
    _createElementVNode("td", _hoisted_10, [
      _createVNode(_component_vSelect, {
        disabled: _ctx.btnDisable,
        selectable: _ctx.calcTax(),
        options: _ctx.opTaxtate,
        modelValue: _ctx.item.c_claim_det_taxrate,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.item.c_claim_det_taxrate) = $event)),
        reduce: (label) => label.code
      }, null, 8, ["disabled", "selectable", "options", "modelValue", "reduce"])
    ]),
    _createElementVNode("td", _hoisted_11, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        style: {"text-align":"right"},
        class: "",
        disabled: "true",
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.item.c_claim_det_price_sum) = $event))
      }, null, 512), [
        [_vModelText, _ctx.item.c_claim_det_price_sum]
      ])
    ]),
    _createElementVNode("td", _hoisted_12, [
      _createVNode(_component_vSelect, {
        disabled: _ctx.btnDisable,
        options: _ctx.opRouding,
        modelValue: _ctx.item.c_claim_det_rounding,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.item.c_claim_det_rounding) = $event)),
        reduce: (label) => label.code
      }, null, 8, ["disabled", "options", "modelValue", "reduce"])
    ]),
    _createElementVNode("td", _hoisted_13, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        style: {"text-align":"left"},
        disabled: _ctx.btnDisable,
        class: "",
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.item.c_claim_det_remarks) = $event))
      }, null, 8, _hoisted_14), [
        [_vModelText, _ctx.item.c_claim_det_remarks]
      ])
    ])
  ]))
}